/**
 * CX Record subscription tiers. Values are the runtime strings stored on forms and exchanged with the API.
 *
 * Device-level recording (monitoring-only, no licence) is controlled by the {@code CXRecordEnabled} device flag.
 */
export enum CXRecordLicences {
    NONE = 'None',
    CXR_USER = 'CXRUser',
    CXR_MANAGER = 'CXRManager'
}
